export const DEFAULT_3D_MODELS_AMOUNT = 10

export const MIN_3D_MODELS_AMOUNT = 1

export const MAX_3D_MODELS_AMOUNT = 100

export const DEFAULT_MODEL_PRICE = 28
